import { RegisteredRouter } from '@tanstack/react-router'
import { createEvent, createStore, sample } from 'effector'

export const setup = createEvent<RegisteredRouter>()

export const $router = createStore<RegisteredRouter>(/* DI */ null!)

sample({ clock: setup, target: $router })
